/* RapidCare - global theme behaviors
   Ported from rc-nav.js; cart rewired to Shopify AJAX Cart API.
   Handles: header scroll, mega-menu, search, mobile drawer, cart drawer,
   AJAX add/change/remove, toast, and shared accordions (FAQ / What's Inside). */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.RC && window.RC.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    // Basic {{amount}} substitution; Shopify handles full formatting server-side.
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ── Toast ─────────────────────────────────────────────── */
  function toast(msg) {
    var t = $('#rcToast');
    if (!t) { t = document.createElement('div'); t.id = 'rcToast'; t.className = 'rc-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2800);
  }

  /* ── Cart (Shopify AJAX API) ───────────────────────────── */
  var Cart = {
    freeShipThreshold: (window.RC && window.RC.freeShipThreshold) || 25000, // cents
    add: function (variantId, qty, title) {
      qty = qty || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      }).then(function (r) { return r.json(); }).then(function () {
        toast((title ? title + ' ' : '') + 'added to cart');
        return Cart.refresh(true);
      }).catch(function () { toast('Could not add to cart'); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { return Cart.refresh(false); });
    },
    get: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); },
    refresh: function (openDrawer) {
      return Cart.get().then(function (cart) {
        Cart.render(cart);
        if (openDrawer) Cart.open();
        return cart;
      });
    },
    render: function (cart) {
      // Count badge
      var countEl = $('.rc-cart-count');
      if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = cart.item_count > 0 ? 'flex' : 'none'; }

      var itemsEl = $('#rcCartItems');
      var footerEl = $('#rcCartFooter');
      var totalEl = $('#rcCartTotal');
      var shipEl = $('#rcCartShip');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="rc-cart-empty">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c3c9d1" stroke-width="1.5" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p>Your cart is empty</p></div>';
        if (footerEl) footerEl.style.display = 'none';
        if (shipEl) shipEl.style.display = 'none';
        return;
      }

      itemsEl.innerHTML = cart.items.map(function (item) {
        var art = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') + '" alt="">'
          : '';
        return '<div class="rc-cart-item" data-key="' + item.key + '">' +
          '<div class="rc-cart-item-art">' + art + '</div>' +
          '<div class="rc-cart-item-info">' +
            '<div class="rc-cart-item-name">' + item.product_title + '</div>' +
            '<div class="rc-cart-item-price">' + money(item.final_line_price) + '</div>' +
            '<div class="rc-cart-qty">' +
              '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
            '<a class="rc-cart-item-remove" data-qty-remove>Remove</a>' +
          '</div>' +
        '</div>';
      }).join('');

      if (totalEl) totalEl.textContent = money(cart.total_price);
      if (footerEl) footerEl.style.display = 'block';

      if (shipEl) {
        shipEl.style.display = 'block';
        var threshold = Cart.freeShipThreshold;
        var remain = threshold - cart.total_price;
        var pct = threshold > 0 ? Math.min(100, Math.round((cart.total_price / threshold) * 100)) : 100;
        var unlocked = remain <= 0;
        var msg = unlocked
          ? '<span class="rc-ship-ico">✓</span> You’ve unlocked <b>FREE shipping</b>'
          : 'Add <b>' + money(remain) + '</b> more for <b>FREE shipping</b>';
        shipEl.innerHTML =
          '<div class="rc-ship-msg">' + msg + '</div>' +
          '<div class="rc-ship-track"><div class="rc-ship-fill' + (unlocked ? ' is-full' : '') +
            '" style="width:' + pct + '%"></div></div>';
      }
    },
    open: function () {
      var d = $('#rcCartDrawer'); if (d) d.classList.add('open');
      var ov = $('#rcNavOverlay'); if (ov) ov.classList.add('show');
    },
    close: function () {
      var d = $('#rcCartDrawer'); if (d) d.classList.remove('open');
      if (!window._rcMegaOpen) { var ov = $('#rcNavOverlay'); if (ov) ov.classList.remove('show'); }
    }
  };
  window.RCCart = Cart;

  /* ── Wire everything on DOM ready ──────────────────────── */
  function init() {
    var overlay = $('#rcNavOverlay');

    /* Header scroll shadow */
    var header = $('#rcHeader');
    if (header) {
      var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 20); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Mega menu (hover + click), desktop */
    var closeTimer = null, currentMega = null;
    function openMega(id) {
      clearTimeout(closeTimer);
      if (currentMega && currentMega !== id) doCloseMega();
      currentMega = id; window._rcMegaOpen = true;
      $$('.rc-mega').forEach(function (m) { m.classList.toggle('open', m.dataset.mega === id); });
      $$('.rc-nav-trigger').forEach(function (t) { t.classList.toggle('mega-open', t.dataset.mega === id); });
      if (overlay) overlay.classList.add('show');
    }
    function doCloseMega() {
      $$('.rc-mega').forEach(function (m) { m.classList.remove('open'); });
      $$('.rc-nav-trigger').forEach(function (t) { t.classList.remove('mega-open'); });
      if (overlay && !$('#rcCartDrawer').classList.contains('open')) overlay.classList.remove('show');
      currentMega = null; window._rcMegaOpen = false;
    }
    function closeMega(immediate) {
      if (immediate) { clearTimeout(closeTimer); doCloseMega(); }
      else { closeTimer = setTimeout(doCloseMega, 150); }
    }
    $$('.rc-nav-trigger').forEach(function (trigger) {
      if (!trigger.dataset.mega) return;
      trigger.addEventListener('mouseenter', function () { openMega(trigger.dataset.mega); });
      trigger.addEventListener('mouseleave', function () { closeMega(); });
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        currentMega === trigger.dataset.mega ? closeMega(true) : openMega(trigger.dataset.mega);
      });
    });
    $$('.rc-mega').forEach(function (m) {
      m.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      m.addEventListener('mouseleave', function () { closeMega(); });
    });

    /* Search */
    var searchBtn = $('#rcSearchBtn'), searchBar = $('#rcSearchBar');
    if (searchBtn) searchBtn.addEventListener('click', function () {
      searchBar.classList.toggle('open');
      if (searchBar.classList.contains('open')) { var i = $('#rcSearchInput'); if (i) i.focus(); closeMega(true); }
    });

    /* Cart drawer */
    var cartBtn = $('#rcCartBtn');
    if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); closeMega(true); Cart.open(); });
    var cartClose = $('#rcCartClose');
    if (cartClose) cartClose.addEventListener('click', Cart.close);

    /* Overlay / Escape close everything */
    if (overlay) overlay.addEventListener('click', function () { closeMega(true); Cart.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(true); Cart.close(); } });

    /* Mobile menu */
    var ham = $('#rcHamburger'), mob = $('#rcMobileMenu'), mobClose = $('#rcMobileClose');
    if (ham) ham.addEventListener('click', function () { mob.classList.add('open'); });
    if (mobClose) mobClose.addEventListener('click', function () { mob.classList.remove('open'); });

    /* Add-to-cart (event delegation - works for cards rendered anywhere) */
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-rc-add]');
      if (addBtn) {
        e.preventDefault();
        var vid = addBtn.getAttribute('data-variant-id');
        var qtyInput = addBtn.closest('[data-product-form]') ? $('[data-qty-input]', addBtn.closest('[data-product-form]')) : null;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (vid) Cart.add(vid, qty, addBtn.getAttribute('data-product-title'));
        return;
      }
      // Cart line qty controls
      var line = e.target.closest('.rc-cart-item');
      if (line) {
        var key = line.getAttribute('data-key');
        var qtyEl = $('.rc-cart-qty span', line);
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (e.target.closest('[data-qty-up]')) { Cart.change(key, current + 1); }
        else if (e.target.closest('[data-qty-down]')) { Cart.change(key, Math.max(0, current - 1)); }
        else if (e.target.closest('[data-qty-remove]')) { Cart.change(key, 0); }
      }
    });

    /* Product-page quantity stepper */
    document.addEventListener('click', function (e) {
      var stepper = e.target.closest('[data-qty-step]');
      if (!stepper) return;
      var wrap = stepper.closest('[data-qty-wrap]');
      var input = wrap ? $('[data-qty-input]', wrap) : null;
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = stepper.getAttribute('data-qty-step') === 'up' ? v + 1 : Math.max(1, v - 1);
      input.value = v;
    });

    /* Initial cart paint */
    Cart.refresh(false);
  }

  /* ── Shared accordion (FAQ, What's Inside) - single open ── */
  window.RCAccordion = function (root) {
    root = root || document;
    $$('[data-accordion]', root).forEach(function (acc) {
      if (acc._rcBound) return; acc._rcBound = true;
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-accordion-trigger]');
        if (!btn) return;
        var item = btn.closest('[data-accordion-item]');
        var body = item.querySelector('[data-accordion-body]');
        var isOpen = item.classList.contains('open');
        $$('[data-accordion-item]', acc).forEach(function (it) {
          it.classList.remove('open');
          var b = it.querySelector('[data-accordion-body]');
          if (b) b.style.maxHeight = '0px';
        });
        if (!isOpen) {
          item.classList.add('open');
          if (body) body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
      // Open first item flagged data-open
      var first = acc.querySelector('[data-accordion-item][data-open]');
      if (first) { first.classList.add('open'); var b = first.querySelector('[data-accordion-body]'); if (b) b.style.maxHeight = b.scrollHeight + 'px'; }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); window.RCAccordion(); });
  } else { init(); window.RCAccordion(); }
})();
